import { SynergyClip } from "../redux/slices/synergy-api/types";

function formatDate(dateString: string): string {
  const date = new Date(dateString);

  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear().toString();

  return `${month}/${day}/${year}`;
}

function formatDurationSeconds(duration: number): string {
  const minutes = Math.floor(duration / 60);
  const seconds = duration % 60;

  const formattedMinutes = minutes.toString().padStart(2, "0");
  const formattedSeconds = seconds.toString().padStart(2, "0");

  return `${formattedMinutes}:${formattedSeconds}`;
}

// format duration milliseconds to mm:ss
function formatDurationMilliseconds(duration: number): string {
  const seconds = Math.floor(duration / 1000);
  return formatDurationSeconds(seconds);
}

function getTeamFromClip(clip: SynergyClip): string {
  let team = "";
  if (clip.eventData.isHome) {
    if (clip.game && clip.game.homeTeam) {
      team = clip.game.homeTeam.name;
    }
  } else if (clip.game && clip.game.awayTeam) {
    team = clip.game.awayTeam.name;
  }
  return team;
}

export { formatDate, formatDurationSeconds, getTeamFromClip, formatDurationMilliseconds };
